/**
 * RegisterPage — registration is now IN PERSON only (the open self-registration
 * path is closed for member/children data security). This page explains how to
 * sign up; the actual form lives on the token-gated /join page reached by
 * scanning a staff-generated QR.
 */
import React from 'react';
import { Box, Container, Paper, Typography, Button, Stack } from '@mui/material';
import { Link } from 'react-router-dom';
import PoolIcon from '@mui/icons-material/Pool';

const RegisterPage: React.FC = () => {
  return (
    <Container maxWidth="sm">
      <Box sx={{ mt: 8, mb: 4 }}>
        <Paper elevation={3} sx={{ p: 4, textAlign: 'center' }}>
          <PoolIcon color="primary" sx={{ fontSize: 48, mb: 1 }} />
          <Typography variant="h5" component="h1" fontWeight={700} gutterBottom>
            Sign up in person
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
            To keep member and family information secure, registration happens in person. Visit the
            front desk and a staff member will show you a sign-up QR code to scan on your phone — you
            can register your whole household on the spot.
          </Typography>
          <Stack direction="row" spacing={2} justifyContent="center">
            <Button variant="contained" component={Link} to="/login">
              Already a member? Log in
            </Button>
          </Stack>
        </Paper>
      </Box>
    </Container>
  );
};

export default RegisterPage;
